import { ZealErrorAlias } from "../../errors";
import { uuid } from "./uuid";

export const partnerID = ({
  description = "Partner ID",
  invalid_pattern_error = ZealErrorAlias.PARTNER_DOES_NOT_EXIST.message,
  required_error = ZealErrorAlias.MISSING_WHITE_LABEL_ID.message,
}: Parameters<typeof uuid>[0] = {}) =>
  uuid({
    description,
    required_error,
    invalid_pattern_error,
  });
